import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass(`with_white_bg`)
}
const _hoisted_3 = {
  class: /*#__PURE__*/_normalizeClass(`llgreyBg rad8 pad20`)
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "fl mr10 fw600" }, "自動作成する", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_6 = { class: "w100" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "fl fw600 mt30 mr10" }, "複製する公開ページのID", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_10 = {
  key: 0,
  class: "fs11 fw600"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_12 = { class: "mt20" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "fl fw600 mr10" }, "複製する公開ページのタイトル", -1)
const _hoisted_14 = { class: "fr" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_16 = { key: 1 }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_21 = { class: "mt20" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", { class: "fl fw600 mr10" }, "確定後に、調整カレンダーのオーナーが調整一覧で表示するタイトル", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_24 = { class: "fr" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_26 = { key: 1 }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_31 = { class: "mt20" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("p", { class: "fl fw600 mr10" }, "確定後に、ゲスト側が調整一覧で表示するタイトル", -1)
const _hoisted_33 = { class: "fr" }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_39 = { class: "mt20" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("p", { class: "fl fw600 mr10" }, "複製時に、グループタグを公開ページに追加します。", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("span", { class: "fw600 fs12" }, "選択したタグ:", -1)
const _hoisted_43 = { key: 0 }
const _hoisted_44 = ["onClick"]
const _hoisted_45 = { key: 1 }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", { class: "fw600 fs12" }, "選択したタグはありません。", -1)
const _hoisted_47 = [
  _hoisted_46
]
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("span", { class: "fw600 fs12" }, "利用可能なタグ:", -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_51 = { class: "mt20" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("p", { class: "fl fw600 mr10" }, "調整カレンダーのオーナーにメールを送信", -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_54 = { class: "fl" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("label", {
  for: `is_send_astag_owner_`,
  class: "fs13 pointer"
}, "送信する", -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_57 = { class: "w100 mt20 centered" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Switcher = _resolveComponent("Switcher")!
  const _component_MdTextfieldTag = _resolveComponent("MdTextfieldTag")!
  const _component_VariableListsContent = _resolveComponent("VariableListsContent")!
  const _component_LblueListContent = _resolveComponent("LblueListContent")!
  const _component_CheckboxTag = _resolveComponent("CheckboxTag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.rcm.selectedRule)
      ? (_openBlock(), _createElementBlock("section", {
          key: 0,
          class: _normalizeClass(`${_ctx.isSP ? `` : ``} mt10`)
        }, [
          (_ctx.rcm.selectedRule.is_active)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", null, [
                    _hoisted_4,
                    _createVNode(_component_Switcher, {
                      value: "type[active]",
                      name: "無効",
                      checked: _ctx.rcm.selectedRule.is_active,
                      display: "true",
                      class: "checkUsingCal fl",
                      onSelect: _ctx.changeActiveRule
                    }, null, 8, ["checked", "onSelect"]),
                    _hoisted_5
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", null, [
                      _hoisted_7,
                      _hoisted_8,
                      _createVNode(_component_MdTextfieldTag, {
                        style: {"height":"56px","min-width":"120px","width":"120px"},
                        fieldStyle: `min-width:120px;font-size:14px;`,
                        class: "fs14 fl",
                        value: _ctx.rcm.selectedRule.copy_pub_room_public_id,
                        onInputValue: _ctx.inputCopyPubRoomPublicId
                      }, null, 8, ["value", "onInputValue"]),
                      _createElementVNode("div", {
                        class: "fl greyBg rad5 mt16 fs11 pointer hoverGreyBg",
                        style: {"padding":"13px","height":"40px"},
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickConnectPublicPage && _ctx.clickConnectPublicPage(...args)))
                      }, " 紐付け "),
                      _hoisted_9,
                      (_ctx.selectedRoom)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, " 「" + _toDisplayString(`[${_ctx.selectedRoom.public_id}]${
                                        _ctx.selectedRoom.appeal_content.title
                                            ? _ctx.selectedRoom.appeal_content.title
                                            : _ctx.selectedRoom.current_appointment.name
                                    }`) + "」を複製して、提案のあった日程をセットします。 ", 1))
                        : _createCommentVNode("", true),
                      _hoisted_11
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _hoisted_13,
                      _createElementVNode("div", _hoisted_14, [
                        (!_ctx.hideTitleButtons)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "pointer fr rad6 borderGrey hoverGrey fs12 padw3",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openValBox(`title`)))
                            }, " +変数を追加 "))
                          : _createCommentVNode("", true),
                        _hoisted_15,
                        (_ctx.openTitleVariables)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                              _createVNode(_component_VariableListsContent, {
                                onSelectVariable: _ctx.selectTitleVariable,
                                type: `title`
                              }, null, 8, ["onSelectVariable"]),
                              _hoisted_17
                            ]))
                          : _createCommentVNode("", true),
                        _hoisted_18
                      ]),
                      _hoisted_19,
                      _createVNode(_component_MdTextfieldTag, {
                        style: {"height":"56px","min-width":"320px","width":"320px"},
                        fieldStyle: `min-width:320px;font-size:14px;`,
                        class: "fs14 fl",
                        value: _ctx.rcm.selectedRule.copy_pub_room_title,
                        onInputValue: _ctx.inputCopyPubRoomTitle
                      }, null, 8, ["value", "onInputValue"]),
                      _hoisted_20
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _hoisted_22,
                      _hoisted_23,
                      _createElementVNode("div", _hoisted_24, [
                        (!_ctx.hideOwnerTitleButtons)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "pointer fr rad6 borderGrey hoverGrey fs12 padw3",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openValBox(`owner_title`)))
                            }, " +変数を追加 "))
                          : _createCommentVNode("", true),
                        _hoisted_25,
                        (_ctx.openOwnerTitleVariables)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                              _createVNode(_component_VariableListsContent, {
                                onSelectVariable: _ctx.selectOwnerTitleVariable,
                                type: `owner_title`
                              }, null, 8, ["onSelectVariable"]),
                              _hoisted_27
                            ]))
                          : _createCommentVNode("", true),
                        _hoisted_28
                      ]),
                      _hoisted_29,
                      _createVNode(_component_MdTextfieldTag, {
                        style: {"height":"56px","min-width":"320px","width":"320px"},
                        fieldStyle: `min-width:320px;font-size:14px;`,
                        class: "fs14 fl",
                        value: _ctx.rcm.selectedRule.astag_owner_open_schedule_title,
                        onInputValue: _ctx.inputOwnerOpenScheduleTitle
                      }, null, 8, ["value", "onInputValue"]),
                      _hoisted_30
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _hoisted_32,
                      _createElementVNode("div", _hoisted_33, [
                        (!_ctx.hideGuestTitleButtons)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "pointer fr rad6 borderGrey hoverGrey fs12 padw3",
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openValBox(`guest_title`)))
                            }, " +変数を追加 "))
                          : _createCommentVNode("", true),
                        (_ctx.openGuestTitleVariables)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                              _createVNode(_component_VariableListsContent, {
                                onSelectVariable: _ctx.selectGuestTitleVariable,
                                type: `guest_title`
                              }, null, 8, ["onSelectVariable"]),
                              _hoisted_35
                            ]))
                          : _createCommentVNode("", true),
                        _hoisted_36
                      ]),
                      _hoisted_37,
                      _createVNode(_component_MdTextfieldTag, {
                        style: {"height":"56px","min-width":"320px","width":"320px"},
                        fieldStyle: `min-width:320px;font-size:14px;`,
                        class: "fs14 fl",
                        value: _ctx.rcm.selectedRule.guest_open_schedule_title,
                        onInputValue: _ctx.inputGuestOpenScheduleTitle
                      }, null, 8, ["value", "onInputValue"]),
                      _hoisted_38
                    ]),
                    _createElementVNode("div", _hoisted_39, [
                      _hoisted_40,
                      _hoisted_41,
                      _createElementVNode("div", null, [
                        _hoisted_42,
                        (_ctx.selectedTags.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedTags, (tag, tagindex) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: _normalizeClass(`fl mr10 mb10 pointer fw600 fs10 rad6 padw3 hoverWhiteBg`),
                                  onClick: ($event: any) => (_ctx.selectTag(`remove`, tag)),
                                  key: `tag${tagindex}`
                                }, [
                                  _createElementVNode("div", {
                                    class: "rad5 fl",
                                    style: _normalizeStyle({
                                                background: `#${tag.color}`,
                                                width: `10px`,
                                                height: `10px`,
                                                marginRight: `5px`,
                                            })
                                  }, "   ", 4),
                                  _createTextVNode(" " + _toDisplayString(tag.name), 1)
                                ], 8, _hoisted_44))
                              }), 128))
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_45, _hoisted_47))
                      ]),
                      _hoisted_48,
                      _createElementVNode("div", null, [
                        _hoisted_49,
                        _createElementVNode("div", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableTags, (tag, tagindex) => {
                            return (_openBlock(), _createBlock(_component_LblueListContent, {
                              key: `tag${tagindex}`,
                              name: tag.name,
                              value: tag.name,
                              class: _normalizeClass(`fl mr10 mb10`),
                              type: `underline`,
                              display: true,
                              showDeleteButton: false,
                              onClickContent: ($event: any) => (_ctx.selectTag(`add`, tag))
                            }, null, 8, ["name", "value", "onClickContent"]))
                          }), 128))
                        ])
                      ]),
                      _hoisted_50
                    ]),
                    _createElementVNode("div", _hoisted_51, [
                      _hoisted_52,
                      _hoisted_53,
                      _createElementVNode("div", _hoisted_54, [
                        _createVNode(_component_CheckboxTag, {
                          name: `is_send_astag_owner`,
                          prefix: `is_send_astag_owner`,
                          value: ``,
                          checked: _ctx.rcm.selectedRule.is_send_astag_owner,
                          onClickCheckbox: _ctx.changeSendMailToAstagOwner
                        }, null, 8, ["checked", "onClickCheckbox"]),
                        _createTextVNode("  "),
                        _hoisted_55
                      ]),
                      _hoisted_56
                    ]),
                    _createElementVNode("div", _hoisted_57, [
                      _createElementVNode("div", {
                        class: "pointer centered circle_button skyblueBg fs14 rad8 fw600",
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.saveRule && _ctx.saveRule(...args)))
                      }, " 保存して戻る "),
                      _hoisted_58
                    ])
                  ]),
                  _hoisted_59
                ])
              ]))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true)
  ]))
}